import { useEffect, useState } from "react";
import withLoader from "../../../../components/layouts/WithLoader";
import { TextField } from "@material-ui/core";
import SellingService from "../../../../services/SellingService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import FactureNonConfirme from "../../../ProductSellBTOB/Table/FactureNonConfirme";

const ListFactureFicheClient = ({ startLoading, stopLoading }) => {
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [clientId, setClientId] = useState(localStorage.getItem("idTiers"));
  const [chargedFactureInfo, setChargedFactureInfo] = useState(false);

  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value.concat(":59"));
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value.concat(":59"));
  };
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [inConfirmedFacture, setInConfirmedFacture] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [caTt, setCaTt] = useState();
  const [caHt, setCaHt] = useState();

  useEffect(() => {
    if (localStorage.getItem("status") === null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }
    startLoading();
    SellingService.getFactureByFiltersOptimized(
      getCurrentUserId(),
      clientId,
      0,
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          setInConfirmedFacture(response.data.success);
          setChargedFactureInfo(true);
          stopLoading();
        }
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :",e);
      });

    startLoading();
    SellingService.getCaByClient(
      getCurrentUserId(),
      clientId,
      0,
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (response.data.caHt) {
          setCaHt(response.data.caHt);
        }
        if (response.data.caTt) {
          setCaTt(response.data.caTt);
        }
        stopLoading();
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :",e);
      });
  }, []);
  const onGetFacturesByFiltersHandler = () => {
    startLoading();
    SellingService.getFactureByFiltersOptimized(
      getCurrentUserId(),
      clientId,
      0,
      dateBegin,
      dateEnd
    )
      .then((response) => {
        console.log("reponse filter", response);
        if (Object.keys(response.data)[0] === "success") {
          setInConfirmedFacture(response.data.success);
          setChargedFactureInfo(true);
          stopLoading();
        } else if (Object.keys(response.data)[0] === "empty") {
        }
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :",e);
      });
      startLoading();
      SellingService.getCaByClient(
        getCurrentUserId(),
        clientId,
        0,
        dateBegin,
        dateEnd
      )
        .then((response) => {
          if (response.data.caHt) {
            setCaHt(response.data.caHt);
          }
          if (response.data.caTt) {
            setCaTt(response.data.caTt);
          }
          stopLoading();
        })
        .catch((e) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :",e);
        });
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">
                Les factures de vente du client{" "}
                <b>{localStorage.getItem("nameTiers")}</b>
              </h5>

              <br />
              <br />
              <div className="row">
                <div className="col-sm-6">
                  {" "}
                  {caTt && (
                    <>
                      <b>CA TTC : </b> {caTt}{" "}
                    </>
                  )}
                </div>
                <div className="col-sm-6">
                  {" "}
                  {caHt && (
                    <>
                      <b>CA HTC : </b> {caHt}{" "}
                    </>
                  )}
                </div>
            
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetFacturesByFiltersHandler}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {chargedFactureInfo && (
        <section className="content ">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <FactureNonConfirme listFacture={inConfirmedFacture} />
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};
export default withLoader(ListFactureFicheClient);
